import Helpers from "@helpers"
import * as React from "react"
import Swal from 'sweetalert2';
import AddressMapModalHelper from "../address-map-modal/address_map_modal"
import AddressModalHelper from "../address-modal/address_modal"
import ShippingListHelper from "../shipping-list/shipping_list"
import { Address, Props, State, Theme } from "./model"
import "./styles.css"

class AddressList extends React.Component<Props, State> {
    constructor(props) {
        super(props)
        this.state = this.getInitialState()
    }

    public async componentDidMount() {
        this.reloadAddressList()
        // if set in initialState then prevState and currentState
        // would be the same and will not load shipping list
        if ($("#hfdAddressId").val()) {
            this.setState({
                selectedAddressId: Helpers.Utils.zeroIfEmpty(
                    $("#hfdAddressId").val().toString()
                ),
            })
        }
    }

    public componentDidUpdate(prevProps: Props, prevState: State) {
        // activate edit mode if address list is empty
        if (
            !this.state.editMode &&
            this.state.addresses &&
            !this.state.addresses.length
        ) {
            this.setState({
                editMode: true,
            })
        }

        // if selected address id is not in the list, clear it
        if (
            this.state.selectedAddressId &&
            this.state.addresses &&
            !this.state.addresses.find((x) => x.ID === this.state.selectedAddressId)
        ) {
            this.setState({
                selectedAddressId: null,
            })
        }

        // update shipping list every time selected address changes
        // because it is an api call check with the old value first
        if (prevState.selectedAddressId !== this.state.selectedAddressId) {
            ShippingListHelper.reloadList(this.state.selectedAddressId)
        }

        // hidden fields should always be in sync with the component state.
        $("#hfdAddressId").val(this.state.selectedAddressId)
    }

    private getInitialState = () => ({
        addresses: null,
        editMode: false,
        selectedAddressId: null,
        uid: 0,
        hps: "",
        forceExUser: 0,
    })

    private onSelectAddress = (addressId) => (e) => {
        if (e.target.className.indexOf("js-exclude") >= 0) {
            return
        }
        this.setState({
            selectedAddressId: null,
        })
        var address = this.state.addresses.find((a) => a.ID == addressId)
        if (address) {
            if (!address.Latitude || !address.Longitude) {
                this.openAddressMapModal(address.ID)()
                return
            }
        }
        this.setState({
            selectedAddressId: addressId,
        })
    }

    private onDeleteAddress = (addressId) => {
        Swal.fire({
            title: 'حذف آدرس',
            text:'آیا از حذف آدرس اطمینان دارید؟',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'حذف',
            cancelButtonText: 'انصراف',
            customClass: {
                confirmButton: 'custom-confirm-button', // اضافه کردن کلاس سفارشی به دکمه تأیید
                cancelButton: 'custom-cancel-button',   // اضافه کردن کلاس سفارشی به دکمه انصراف
            },
        }).then((result) => {
            if (result.isConfirmed) {
  

                var forceExUser = 0
                var uid = 0
                var hps = ""

                if ($("#hdfForceExUser").length > 0) {
                    forceExUser = Helpers.Utils.zeroIfEmpty(
                        $("#hdfForceExUser").val().toString()
                    )
                }
                if ($("#hdfUId").length > 0) {
                    uid = Helpers.Utils.zeroIfEmpty($("#hdfUId").val().toString())
                }
                if ($("#hdfHps").length > 0) {
                    hps = $("#hdfHps").val().toString()
                }

                Helpers.ApiHelper.deleteAddress(addressId, forceExUser, uid, hps)
                    .then((_) => {
                        this.reloadAddressList()
                        Swal.fire({
                            text: 'آدرس مورد نظر با موفقیت حذف شد!',
                            icon: 'success',
                            timer: 3000,
                            cancelButtonText: 'باشه',
                        })
                    })
                    .always((_) => {
                    })



            }
        });
    }

    private getItemsTemplate = (address: Address, theme: Theme) => {
        if (theme === "List") return this.getListTemplate(address)
        if (theme === "Grid") return this.getGridTemplate(address)
    }

    private getListTemplate = (address: Address) => (
        <div
            key={address.ID}
            className={`order-address-row ${address.ID === this.state.selectedAddressId ? "active" : ""
                }`}
            onClick={this.onSelectAddress(address.ID)}
        >
            <div className="address-list-item">
                <div className="address-select-container">
                    <div className="address-select-circle">
                        <i className="fa fa-check-square fa-lg address-select-icon" />
                    </div>
                </div>

                <span className="address-text">{address.Address}</span>
            </div>

            <div className="address-buttons-container">
                <span
                    className="btn-transparent btn-xsmall address-edit-button js-exclude"
                    onClick={this.openAddressMapModal(address.ID)}
                >
                    ویرایش
                </span>

                <span
                    className="btn-transparent btn-xsmall js-exclude"
                    onClick={() => this.onDeleteAddress(address.ID)}
                >
                    حذف
                </span>
            </div>
        </div>
    )

    private getGridTemplate = (address: Address) => (
        <div key={address.ID} className="address-item">
            <div className="address-content">{address.Address}</div>
            <div className="address-buttons">
                <span
                    className="btn-transparent address-edit-button"
                    onClick={this.openAddressMapModal(address.ID)}
                >
                    ویرایش
                </span>
                <span
                    className="btn-transparent"
                    onClick={() => this.onDeleteAddress(address.ID)}
                >
                    حذف
                </span>
            </div>
        </div>
    )

    private getAddButtonTemplate = (theme: Theme) => {
        if (theme === "List") return this.getListAddButtonTemplate()
        if (theme === "Grid") return this.getGridAddButtonTemplate()
    }

    private openAddressMapModal = (addressId = null) =>
        () => {
            if (window.location.pathname == '/Admin/ProductFactorNew.aspx') {
                this.openAddressModal(addressId);
            }
            else {
                Helpers.LoadingHelper.showLoading()
                setTimeout(() => {
                    AddressMapModalHelper.openAddressModal(
                        addressId,
                        this.openAddressModal.bind(this)
                    )
                }, 500)
            }
        }

    private openAddressModal(
        addressId = null,
        address = null,
        lat = null,
        lng = null
    ) {
        AddressModalHelper.openAddressModal(
            addressId,
            address,
            lat,
            lng,
            this.reloadAddressList.bind(this)
        )
    }

    private reloadAddressList() {
        Helpers.LoadingHelper.showLoading()

        var forceExUser = 0
        var uid = 0
        var hps = ""

        if ($("#hdfForceExUser").length > 0) {
            forceExUser = Helpers.Utils.zeroIfEmpty(
                $("#hdfForceExUser").val().toString()
            )
        }
        if ($("#hdfUId").length > 0) {
            uid = Helpers.Utils.zeroIfEmpty($("#hdfUId").val().toString())
        }
        if ($("#hdfHps").length > 0) {
            hps = $("#hdfHps").val().toString()
        }

        Helpers.ApiHelper.getAddresses(forceExUser, uid, hps)
            .then((addresses) => {
                this.setState({
                    addresses,
                })
            })
            .always((_) => {
                Helpers.LoadingHelper.hideLoading()
            })
    }

    private getListAddButtonTemplate = () => (
        <div className="order-new-address" onClick={this.openAddressMapModal()}>
            <i className="fa fa-lg fa-plus"></i>
            ایجاد آدرس جدید
        </div>
    )

    private getGridAddButtonTemplate = () => (
        <div
            className="add-address-container p-0 w-100"
            onClick={this.openAddressMapModal()}
        >
            <div className="add-address-label">افزودن آدرس جدید</div>
        </div>
    )

    private toggleEdit = () => {
        this.setState({
            editMode: !this.state.editMode,
        })
    }

    private getAddressContainerClass = (classNames: string) => {
        let result = classNames
        if (this.state.editMode) {
            result += " edit-mode"
        }

        return result
    }

    private getToggleLabel = () =>
        this.state.editMode ? "اتمام ویرایش" : "ویرایش آدرس‌ها"

    private hasHeader = (): boolean =>
        this.props.header && this.props.header.toLocaleLowerCase() === "true"
            ? true
            : false

    private isListEmpty = () =>
        !this.state.addresses || this.state.addresses.length === 0

    private getHeaderTemplate = () => {
        if (this.hasHeader()) {
            return (
                <div className="address-header-container">
                    <h2>آدرس گیرنده</h2>
                    <div
                        style={{ display: this.isListEmpty() ? "none" : "block" }}
                        onClick={this.toggleEdit}
                        className="address-edit-mode-button"
                    >
                        {this.getToggleLabel()}
                    </div>
                </div>
            )
        }

        return null
    }

    public render() {
        const itemsTemplate =
            this.state &&
            this.state.addresses &&
            this.state.addresses.map((address) =>
                this.getItemsTemplate(address, this.props.theme)
            )

        const addButtonTemplate = this.getAddButtonTemplate(this.props.theme)

        const headerTemplate = this.getHeaderTemplate()

        return (
            <div>
                {headerTemplate}

                <div
                    className={
                        this.getAddressContainerClass("address-container") + " row"
                    }
                >
                    <div className="col-12">{addButtonTemplate}</div>

                    <div className="col-12">
                        <div className="address_items-container p-2 w-100">
                            {itemsTemplate}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

Helpers.ReactHelper.createReactElement("AddressList", AddressList)
